import {
  useBasicAuthOptions,
  useRequiredRequestOptions,
  useRowQueryOptions,
} from '../query-options';
import {
  useQueryLibraryGetOneRow,
  useQueryUserLibraryGetRows,
} from '@ifit/gateway-wolf-athenaeum-service';
import getNextPageParam from '../get-next-page';

export const useGetRowsQuery = () =>
  useQueryUserLibraryGetRows({
    ...useRowQueryOptions(),
    ...useBasicAuthOptions(),
  });

export const useGetOneRowQuery = rowTitle => {
  const {
    softwareNumber,
    membershipType,
    headers,
    useGatewayCache,
  } = useRequiredRequestOptions();
  return useQueryLibraryGetOneRow(
    {
      rowTitle,
      softwareNumber,
      membershipType,
      headers,
      useGatewayCache,
      ...useBasicAuthOptions(),
    },
    { getNextPageParam },
  );
};
